import React from 'react'
import { Global } from '@emotion/react'
// import { SWRConfig } from 'swr'
import { StateMachineProvider, createStore } from "little-state-machine";

// import HeaderProvider from './src/contexts/header/Provider'
import FirebaseProvider from './src/contexts/firebase/provider'
import FirebaseSDK from './src/contexts/firebase/sdk'
import { MediaContextProvider } from './src/contexts/responsive'
import IpProvider from './src/contexts/ip/provider'
import globalStyles from './src/helpers/global-styles';

createStore({
  // donate: {},
  contact: {},
}, { name: 'portaly' });

const WithProvider = ({ element }) => {
  const normalChild = (
    <MediaContextProvider>
      <StateMachineProvider>
        <IpProvider>
          <>
            <Global styles={globalStyles} />
            {element}
          </>
        </IpProvider>
      </StateMachineProvider>
    </MediaContextProvider>
  )
  if (typeof window === "undefined") {
    return normalChild
  }
  return (
    <FirebaseProvider>
      <FirebaseSDK>
        {normalChild}
      </FirebaseSDK>
    </FirebaseProvider>
  )
}

export default WithProvider
